const API_DIGITALGROW_DETAILS = [
    'details_section.translations.text',
    'details_section.translations.title',
    'details_section.metrics.dg_details_metric_id.value',
    'details_section.metrics.dg_details_metric_id.icon',
    'details_section.metrics.dg_details_metric_id.translations.category'
];
const API_DIGITALGROW_DIGITAL_PLATFORM = [
    'platform_section.translations.title',
    'platform_section.translations.text',
    'platform_section.translations.formation_profiles_title',
    'platform_section.translations.formation_image',
    'platform_section.translations.users_title',
    'platform_section.translations.users_image',
    'platform_section.translations.users_description',
    'platform_section.formation_profiles.dg_formation_profiles_id.color',
    'platform_section.formation_profiles.dg_formation_profiles_id.value',
    'platform_section.formation_profiles.dg_formation_profiles_id.translations.description'
];
const API_DIGITALGROW_DIGITAL_LIBRARY = [
    'library_section.translations.title',
    'library_section.translations.text',
    'library_section.translations.topics_title',
    'library_section.translations.chart_image',
    'library_section.translations.chart_description',
    'library_section.metrics.dg_library_metrics_id.value',
    'library_section.metrics.dg_library_metrics_id.icon',
    'library_section.metrics.dg_library_metrics_id.translations.name',
    'library_section.topics.dg_library_topics_id.translations.name',
    'library_section.topics.dg_library_topics_id.translations.link'
];
export { API_DIGITALGROW_DETAILS, API_DIGITALGROW_DIGITAL_PLATFORM, API_DIGITALGROW_DIGITAL_LIBRARY };
